import { initializeApp, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { initializeFirestore, getFirestore, persistentLocalCache } from 'firebase/firestore';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL
};

// Check if Firebase app is already initialized
let app;
try {
  app = initializeApp(firebaseConfig);
} catch (error) {
  // If app already exists, get the existing one
  if (error.code === 'app/duplicate-app') {
    app = getApp();
  } else {
    throw error;
  }
}

// Initialize Firebase Authentication
const auth = getAuth(app);

// Initialize Firestore with offline persistence (only once)
let db;
try {
  db = initializeFirestore(app, {
    localCache: persistentLocalCache({
      // Cache size: 100MB
      cacheSizeBytes: 100 * 1024 * 1024,
    }),
  });
  
  // Note: enableIndexedDbPersistence is deprecated, using FirestoreSettings.cache instead
  // Offline persistence is now handled by persistentLocalCache above
} catch (error) {
  // If Firestore is already initialized, get the existing instance
  if (error.message.includes('cache is already specified')) {
    console.log('Firestore cache already specified, using existing instance');
    db = getFirestore(app);
  } else {
    throw error;
  }
}

// Initialize Realtime Database
const rtdb = getDatabase(app);

// Initialize Firebase Storage
const storage = getStorage(app);

export { auth, db, rtdb, storage };
export default app; 